<template>
  <div class="flex sharing-v">
    <Header />
    <Step />
    <div class="form-area">
      <a-form id="accountLoginForm" :form="form" @submit="formSubmitAct">
        <a-row>
          <a-col :xs="24" :sm="12" :md="10" :lg="8" :xl="6">
            <a-form-item label="报考人员类型">
              <a-radio-group
                name="idType"
                @change="selectStudentType"
                v-decorator="[
                  'idType',
                  { initialValue: userInfo.idType ? userInfo.idType : 1 },
                ]"
              >
                <a-radio :value="1">大陆居民</a-radio>
                <a-radio :value="2">非大陆居民</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <a-form-item label="证件类型">
              <a-radio-group
                name="idPaperType"
                v-decorator="[
                  'idPaperType',

                  {
                    initialValue: userInfo.idPaperType
                      ? userInfo.idPaperType
                      : personType == 1
                      ? 1
                      : 3,
                  },
                ]"
              >
                <a-radio :value="1" v-if="personType == 1">身份证</a-radio>
                <a-radio :value="2" v-if="personType == 1">临时身份证</a-radio>
                <a-radio :value="3" v-if="personType != 1">护照</a-radio>
                <a-radio :value="4" v-if="personType != 1">港澳通行证</a-radio>
                <a-radio :value="5" v-if="personType != 1">台湾通行证</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
        </a-row>
        <div class="row-item">
          <div class="form-title">上传证件照：</div>
          <a-row :gutter="16">
            <a-col :xs="24" :sm="12" :md="12" :lg="10" :xl="8">
              <a-form-item>
                <a-upload
                  name="avatar"
                  accept="image/*"
                  v-decorator="[
                    'frontUrl',
                    {
                      getValueFromEvent: normFile,

                      rules: [{ required: true, message: '请上传正面证件照' }],
                      initialValue: frontUrl ? frontUrl : '',
                    },
                  ]"
                  :beforeUpload="beforeUpload"
                  @change="frontHandleChange"
                  listType="picture-card"
                  class="certificate-uploader"
                  :showUploadList="false"
                >
                  <img
                    :src="
                      frontUrl ? frontUrl : require('@/assets/images/front.png')
                    "
                    alt="certificate"
                    name="frontUrl"
                  />
                  <div class="btn-plus flex sharing-v" v-if="!frontUrl">
                    <a-icon
                      :type="loading1 ? 'loading' : 'plus'"
                      style="font-size: 24px; margin-bottom: 5px"
                    />
                    <div class="ant-upload-text">证件正面照</div>
                  </div>
                </a-upload>
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="12" :md="12" :lg="10" :xl="8">
              <a-form-item>
                <a-upload
                  name="avatar"
                  accept="image/*"
                  v-decorator="[
                    'backUrl',
                    {
                      getValueFromEvent: normFile,

                      rules: [{ required: true, message: '请上传反面证件照' }],
                      initialValue: backUrl ? backUrl : '',
                    },
                  ]"
                  :beforeUpload="beforeUpload"
                  @change="backHandleChange"
                  listType="picture-card"
                  class="certificate-uploader"
                  :showUploadList="false"
                >
                  <img
                    :src="
                      backUrl ? backUrl : require('@/assets/images/back.png')
                    "
                    alt="avatar"
                  />
                  <div class="btn-plus flex sharing-v" v-if="!backUrl">
                    <a-icon
                      :type="loading2 ? 'loading' : 'plus'"
                      style="font-size: 24px; margin-bottom: 5px"
                    />
                    <div class="ant-upload-text">证件反面照</div>
                  </div>
                </a-upload>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
        <a-row :gutter="16">
          <a-col :xs="24" :sm="12" :md="10" :lg="6" :xl="5">
            <a-form-item label="姓名/护照名">
              <a-input
                placeholder="姓名/护照名"
                v-decorator="[
                  'idName',
                  {
                    rules: [
                      { required: true, message: '请输入姓名/护照名' },
                      { max: 18, message: '请输入正确的姓名/护照名' },
                    ],
                    initialValue: userInfo.idName,
                  },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="6" :xl="5">
            <a-form-item label="证件号码">
              <a-input
                v-decorator="[
                  'idNo',

                  {
                    rules: [{ required: true, message: '请输入证件号码' }],
                    initialValue: userInfo.idNo,
                  },
                ]"
                placeholder="证件号码"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :xs="24" :sm="12" :md="12" :lg="6" :xl="5">
            <a-form-item label="性别">
              <a-select
                name="gender"
                v-decorator="[
                  'gender',
                  { initialValue: userInfo.gender ? userInfo.gender : '男' },
                ]"
              >
                <a-select-option value="男">男</a-select-option>
                <a-select-option value="女">女</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="6" :xl="5">
            <a-form-item label="出生日期">
              <a-date-picker
                v-decorator="[
                  'birthday',

                  {
                    rules: [{ required: true, message: '请输入出生日期' }],
                    initialValue: userInfo.birthday
                      ? moment(userInfo.birthday, 'YYYY-MM-DD')
                      : moment('2020-01-01', 'YYYY-MM-DD'),
                  },
                ]"
                placeholder="出生日期"
                format="YYYY-MM-DD"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item class="text-center">
          <a-button type="primary" html-type="submit">下一步</a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
// function getBase64(img, callback) {
//   const reader = new FileReader();
//   reader.addEventListener("load", () => callback(reader.result));
//   reader.readAsDataURL(img);
// }
// @ is an alias to /src
import Header from "../components/Header";
import Step from "../components/common/step";
import moment from "moment";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers("apply");
export default {
  name: "Login",
  components: {
    Header,
    Step,
  },
  data() {
    return {
      loading1: false,
      loading2: false,
      frontUrl: "",
      backUrl: "",
      personType: 1,
      // formLayout: "horizontal",
      form: this.$form.createForm(this),
      userInfo: {},
    };
  },
  computed: {
    ...mapState({
      studentInfo: (state) => state.studentInfo,
    }),
  },
  mounted() {
    let userInfo = JSON.parse(localStorage.getItem("apply_userInfo"));
    this.getStudentInfo({
      orderCode: userInfo.orderCode,
      userCode: userInfo.userCode,
      examCode: userInfo.examCode,
    }).then((res) => {
      let studentInfo = res.data;
      if (studentInfo.status == "2000") {
        this.frontUrl = studentInfo.data.idUrl1;
        this.backUrl = studentInfo.data.idUrl2;
        this.userInfo = studentInfo.data;
        this.personType = this.userInfo.idType;
      } else {
        this.userInfo = userInfo;
      }
    });
  },
  methods: {
    moment,
    ...mapActions([
      "getStudentInfo",
      "addStudentAction",
      "updateStudentAction",
      "getPicUrl",
    ]),
    selectStudentType(e) {
      //        console.log(   this.form.getFieldsValue(
      // idPaperType
      // ))

      if (e.target.value == 1) {
        this.form.setFieldsValue({
          idPaperType: 1,
        });
      } else {
        this.form.setFieldsValue({
          idPaperType: 3,
        });
      }

      this.personType = e.target.value;
    },
    formSubmitAct(e) {
      let studentInfo = JSON.parse(localStorage.getItem("studentInfo"));
      if (studentInfo && studentInfo.status) {
        this.updateStudentSubmit(e);
      } else {
        this.createStudentSubmit(e);
      }
    },
    createStudentSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          let userInfo = JSON.parse(localStorage.getItem("apply_userInfo"));
          values.idUrl1 = this.frontUrl;
          values.idUrl2 = this.backUrl;
          values.birthday = values.birthday.format("YYYY-MM-DD");
          values.userCode = userInfo.userCode;
          values.orderCode = userInfo.orderCode;
          values.examCode = userInfo.examCode;
          values.agencyCode = userInfo.agencyCode;
          values.agencyName = userInfo.agencyName;

          let formData = new FormData();
          // fields 是表單內容，將它 append 到 formData
          Object.keys(values).map((item) => {
            formData.append(item, values[item]);
          });
          this.addStudentAction(formData).then((res) => {
            this.applyStatusJudge(res.data);
          });
        }
      });
    },
    updateStudentSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        console.log(err);
        if (!err) {
          let userInfo = JSON.parse(localStorage.getItem("studentInfo"));
          // values.frontalFile = values.frontalFile[0].originFileObj;
          // values.backFile = values.backFile[0].originFileObj;
          values.idUrl1 = this.frontUrl;
          values.idUrl2 = this.backUrl;
          values.birthday = values.birthday.format("YYYY-MM-DD");
          values.userCode = userInfo.userCode;
          values.orderCode = userInfo.orderCode;
          values.examCode = userInfo.examCode;
          values.agencyCode = userInfo.agencyCode;
          values.agencyName = userInfo.agencyName;
          values.enrollInfoId = userInfo.enrollInfoId;
          values.examCode = userInfo.examCode;
          values.updateType = 1;

          let formData = new FormData();
          // fields 是表單內容，將它 append 到 formData
          Object.keys(values).map((item) => {
            formData.append(item, values[item]);
          });
          this.updateStudentAction(formData).then((res) => {
            if (res.data.status == 2000) {
              this.$router.push("/profile");
            } else {
              this.$warning({
                title: res.data.message,
                content: res.data.message,
                okText: "知道了",
                okType: "primary",
                maskClosable: true,
                onOk() { },
                onCancel() { },
              });
            }
          });
        }
      });
    },
    normFile(e) {
      if (Array.isArray(e)) {
        return e;
      }
      return e && e.fileList;
    },
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      if (!isJPG) {
        this.$message.error("文件格式为jpg、png!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("图片大小不大于2M!");
      }
      return isJPG && isLt2M;
    },
    frontHandleChange(info) {
      if (info.file.status === "uploading") {
        this.loading1 = true;
        return;
      } else {
        // getBase64(info.file.originFileObj, imageUrl => {
        let formData = new FormData();
        formData.append("file", info.file.originFileObj);
        this.getPicUrl(formData).then((res) => {
          if (res.data.status == 2000) {
            this.frontUrl = res.data.data;
          }

        });
        //    console.log(imageUrl)
        this.loading1 = false;
        // });
      }
      // if (info.file.status === "done") {
      //   // Get this url from response in real world.
      //   getBase64(info.file.originFileObj, frontUrl => {
      //     this.frontUrl = frontUrl;
      //     this.loading1 = false;
      //   });
      // }
    },
    backHandleChange(info) {
      if (info.file.status === "uploading") {
        this.loading2 = true;
        return;
      } else {
        let formData = new FormData();
        formData.append("file", info.file.originFileObj);
        this.getPicUrl(formData).then((res) => {
          if (res.data.status == 2000) {
            this.backUrl = res.data.data;
          }

        });
        // getBase64(info.file.originFileObj, imageUrl => {
        // this.backUrl = imageUrl;
        this.loading2 = false;
        // });
      }
    },
    applyStatusJudge(data) {
      if (data.status == 2000) {
        this.$router.push("/profile");
      } else {
        this.$warning({
          title: data.message,
          content: data.message,
          okText: "知道了",
          okType: "primary",
          maskClosable: true,
        });
      }
    },
  },
};
</script>

<style scoped>
.form-title {
  margin-bottom: 15px;
  text-align: left;
  font-size: 14px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 20px;
}
.form-item {
  align-items: flex-start;
}
.papers-box {
  justify-content: flex-start;
}
.identity-card {
  margin-right: 20px;
}
.identity-card img {
  width: 300px;
  margin-bottom: 10px;
}
.authen-img {
  display: block;
  width: 100%;
}
.img-tip {
  position: absolute;
  left: 0;
  bottom: 40px;
  width: 100%;
}
</style>